<template>
  <div id="design-process">
    <div class="section padding-page-top padding-bottom-big">
      <div class="container">
        <div class="row page-title px-4 px-xl-2">
          <transition name="fade">
            <div v-if="isMobile" class="col-12 col-md-6">
              <div class="row mb-5 pb-5">
                <div class="col-md-1">MY DESIGN PROCESS</div>
                <div class="col-md-11">
                  <h1 class="mb-5 mb-sm-3">
                    through <span class="highlight">strategy</span>,
                    <span class="highlight">creativity</span> and
                    <span class="highlight">communication.</span>
                  </h1>
                  <router-link to="/about" class="h3 main-button " tag="a"
                    >how I work</router-link
                  >
                </div>
              </div>
            </div>

            <div
              v-else
              class="col-12 col-md-6"
              :style="{
                opacity: `${2.2 - scrollPos / 200}`,
                top: `${-scrollPos + 500}px`
              }"
            >
              <div class="row mb-5 pb-5 justify-content-center">
                <div class="col-lg-11 order-2 order-lg-1">
                  <h1 class="mb-5 mb-sm-3">
                    through <span class="highlight">strategy</span>,
                    <span class="highlight">creativity</span> and
                    <span class="highlight">communication.</span>
                  </h1>
                  <router-link to="/about" class="h3 main-button " tag="a"
                    >how I work</router-link
                  >
                </div>
                <div class="col-lg-1 order-1 order-lg-2">MY DESIGN PROCESS</div>
              </div>
            </div>
          </transition>

          <div class="col-10 col-md-6">
            <ul class="gravity-wrapper">
              <li class="absolute" v-for="n in 5" :key="n">
                <img
                  class="img-fluid"
                  :src="require(`@/assets/img/gravity/0${n}.png`)"
                  alt="ui mockups"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollPosition } from "@/components/utils";
export default {
  data() {
    return {
      scrollPos: 0,
      isMobile: window.innerWidth < 800 ? true : false,
      scrollingAnimation: null
    };
  },
  computed: {
    animationProgress() {
      return this.value_limit(
        (this.scrollPos * 200) / this.$el.clientHeight,
        0,
        100
      );
    },
    absolutes() {
      return document.querySelectorAll(".absolute");
    }
  },
  methods: {
    value_limit(val, min, max) {
      return val < min ? min : val > max ? max : val;
    },
    scrollBanner() {
      window.addEventListener(
        "scroll",
        (this.scrollingAnimation = () => {
          this.scrollPos = scrollPosition(this.$el);

          for (let index = 0; index < this.absolutes.length; index++) {
            if (index == 0) {
              this.absolutes[index].style.top = `${100 -
                this.animationProgress}%`;
            } else if (index === 1) {
              this.absolutes[index].style.top = `${50 -
                this.animationProgress / 2}%`;
            } else if (index === 3) {
              this.absolutes[index].style.top = `${-50 +
                this.animationProgress / 2}%`;
            } else if (index === 4) {
              this.absolutes[index].style.top = `${-100 +
                this.animationProgress}%`;
            }
          }
        })
      );
    },
    checkSize() {
      if (window.innerWidth < 800) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  },
  watch: {
    isMobile(value) {
      if (value === false) {
        this.scrollBanner();
      }
    }
  },
  mounted() {
    if (!this.isMobile) {
      this.scrollBanner();
    }
    window.addEventListener("resize", this.checkSize);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollingAnimation);
    window.removeEventListener("resize", this.checkSize);
  }
};
</script>

<style lang="scss" scoped>
#design-process {
  min-height: 120vh;
  height: fit-content;
}

.gravity-wrapper {
  position: relative;
  height: 100%;
  list-style-type: none;
}

.absolute {
  position: absolute;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: 0.3s all ease;
}
</style>
